import { fetchCountries } from 'actions/otherActions';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import * as Storage from 'utils/storage';
import '../../assets/scss/keepspace-css/admin/_global.scss';
import { NavBar, TopBar } from './components';


const UserLayout = props => {
  const { route, location } = props;
  const dispatch = useDispatch();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  const [showDesktopSidebar, setShowDesktopSidebar] = useState(false);

  // Auto-hide the desktop sidebar on any dashboard-related pages.
  // If the pathname includes "/dashboard" (main dashboard, orders dashboard, etc.),
  // keep the sidebar hidden. Otherwise, show it on all other admin pages.
  useEffect(() => {
    if (location.pathname.includes('dashboard')) {
      setShowDesktopSidebar(false);
    } else {
      setShowDesktopSidebar(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Toggle sidebar on Command+B (Mac) or Ctrl+B (Windows/Linux)
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'b') {
        event.preventDefault();
        setShowDesktopSidebar(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true);
  };

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };
  const getCountries = async () => {
    const ADMIN = Storage.getItem('_ADMIN');
    if (ADMIN) {
      await dispatch(fetchCountries());
    }


  };
  useEffect(() => {

    getCountries();
  }, []);


  return (
    <div className="appRoot">
      <TopBar
        className="topBar"
        onOpenNavBarMobile={handleNavBarMobileOpen}
        setShowDesktopSidebar={setShowDesktopSidebar}
      />

      <div className="container rootContainer">

        {!location.pathname.includes('admin/errors') && <NavBar
          className={openNavBarMobile ? 'navBar' : showDesktopSidebar ? 'navBar navOpen' : 'navBar navClosed'}
          onMobileClose={handleNavBarMobileClose}
          onMobileOpen={handleNavBarMobileOpen}
          openMobile={openNavBarMobile}
          toggleState={{ showDesktopSidebar, setShowDesktopSidebar }}
        />}

        <main className="main">
          {/* <Suspense fallback={<LinearProgress />}> */}
          {renderRoutes(route.routes)}
          {/* </Suspense> */}
        </main>

      </div>

    </div>
  );
};

UserLayout.propTypes = {
  route: PropTypes.object,
};

export default UserLayout;
